import {FileData} from "@/pages/buddy/types/FileData.ts";
import {MatchDetailsData} from "@/pages/buddy/types/MatchDetailsData.ts";
import {Characteristic} from "@/pages/buddy/types/Characteristic.ts";

export interface JobDetailsData {

    p_id: string;
    is_active: boolean;
    created_at: string | null;
    updated_at: string | null;

    name: string;
    company_name: string; // Updated to use full company name
    company_p_id: string; // Added to include the company's unique ID
    company_image_url: string;

    location: string | null;
    remote: string | null;
    employment_type: string | null;
    salary_range: string | null;

    description: string | null;

    required_skills: Characteristic[];
    frameworks: Characteristic[];
    technologies: Characteristic[];
    required_languages: Characteristic[];
    benefits: string[];
    role_responsibilities: string[];

    years_of_experience?: number | null;
    education_level?: string | null;
    reporting_to?: string | null;
    team_size?: number | null;
    posted_at?: string | null;
    closing_date?: string | null;

    files: FileData[];

    matches: MatchDetailsData[]; // Added to include matches for the job
    image_url?: string | null;

    llm_log?: ILLMLogEntry[];

}

type FieldType = 'text' | 'date' | 'boolean' | 'array' | 'number';

interface FieldConfig {
    label: string;
    editable: boolean;
    type: FieldType;
    display?: boolean; // Whether to display this field
}

export const jobFieldConfig: Record<keyof JobDetailsData, FieldConfig> = {
    p_id: {label: 'Job ID', editable: false, type: 'text', display: false},

    name: {label: 'Job Title', editable: true, type: 'text', display: true},
    company_name: {label: 'Company Name', editable: false, type: 'text', display: true},
    company_p_id: {label: 'Company ID', editable: false, type: 'text', display: false},
    company_image_url: {label: 'Company Image', editable: false, type: 'text', display: false},

    location: {label: 'Location', editable: true, type: 'text', display: true},
    remote: {label: 'Remote', editable: true, type: 'text', display: true},
    employment_type: {label: 'Employment Type', editable: true, type: 'text', display: true},
    salary_range: {label: 'Salary Range', editable: true, type: 'text', display: true},

    description: {label: 'Job Description', editable: true, type: 'text', display: false},

    required_skills: {label: 'Required Skills', editable: true, type: 'array', display: false},
    frameworks: {label: 'Frameworks', editable: true, type: 'array', display: false},
    technologies: {label: 'Technologies', editable: true, type: 'array', display: false},
    required_languages: { label: 'Languages', editable: true, type: 'array', display: false },
    benefits: {label: 'Benefits', editable: true, type: 'array', display: false},
    role_responsibilities: {label: 'Role Responsibilities', editable: true, type: 'array', display: false},

    years_of_experience: {label: 'Years of Experience', editable: true, type: 'number', display: true},
    education_level: {label: 'Education Level', editable: true, type: 'text', display: true},
    reporting_to: {label: 'Reporting To', editable: true, type: 'text', display: true},
    team_size: {label: 'Team Size', editable: true, type: 'number', display: true},
    posted_at: {label: 'Posted At', editable: false, type: 'date', display: true},
    closing_date: {label: 'Closing Date', editable: false, type: 'date', display: true},

    is_active: {label: 'Is Active', editable: true, type: 'boolean', display: true},
    created_at: {label: 'Created At', editable: false, type: 'date', display: true},
    updated_at: {label: 'Updated At', editable: false, type: 'date', display: true},

    files: {label: 'Files', editable: false, type: 'array', display: false},
    image_url: {label: 'Image', editable: false, type: 'text', display: true},

    matches: {label: 'Matches', editable: false, type: 'array', display: true}, // Added for matches

    llm_log: { label: 'LLM Log', editable: false, type: 'array', display: false },
};
